import {Role} from '@/_helpers/role';

export class User {
    public role: Role = Role.User;
    constructor(
        public id: number,
        public firstName: string,
        public lastName: string,
        public username: string,
        public token: string,
    ) {}
}
